<template>
  <div class="financeiros_aberto-cliente">

    <div 
      id="modalFinanceiroAbertos"
      class="w3-modal" 
      v-if="abrir_modal_financeiros_abertos"
      style="display: block; padding-top: 30px;"
      v-cloak>
      
      <div class="w3-modal-content w3-animate-zoom w3-container" @click.stop>
        
        <header>
          <h4 class="texto-vermelho w3-center">Financeiros Abertos</h4>
          <span @click="abrir_modal_financeiros_abertos = false" class="w3-button w3-display-topright">&times;</span>
        </header>

        <div class="w3-row-padding w3-margin-bottom" style="max-height: calc(80vh - 50px); min-height: 100px; overflow: auto">
          
          <div style="margin-bottom: 10px;">
            <legenda>
              <span>Cliente</span>
              <i slot="referencia" class="fa fa-user-tag texto-vermelho"></i>
            </legenda>
            <strong id="eResultado">{{formatarValor(dados_cliente.cadastro_id, 0)}} - {{dados_cliente.nome_razao_social}}</strong>
          </div>

          <div class="w3-container card-item w3-border w3-animate-left" v-for="(financeiro, index) in financeiros_abertos" :key="index" v-cloak>
            
            <div v-on:click="mostrarDetalhes(index)">
              
              <div class="w3-left w3-col s12">
                <legenda>
                  <span>Financeiro</span>
                  <i slot="referencia" class="fa fa-file-alt texto-vermelho"></i>
                </legenda>
                <label class="texto-vermelho" data-label="resultado-venda" id="eResultado">Financeiro: <strong> {{financeiro.financeiro_id}} </strong></label>
              </div>
              
              <label class="w3-col s12">Tipo: {{financeiro.tipo_analitico_menor}}</label>
              <label class="w3-col s12">Vencimento: {{financeiro.data_vencimento}}</label>
              <label class="w3-col s12">Valor documento: <strong class="w3-text-green"> {{financeiro.valor_documento}} </strong></label>

              <i v-show="!financeiro.expandir" style="color: #7a7a7a;" class="w3-col s12 w3-center fas fa-ellipsis-h"></i>  
              <label v-show="financeiro.expandir" class="w3-col s12">Status: {{financeiro.status_analitico}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Documento: {{financeiro.documento}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Emissão: {{financeiro.data_emissao}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Vencimento: {{financeiro.data_vencimento_util}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Empresa: {{financeiro.empresa_id}} - {{financeiro.nome_resumido_empresa}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Juros: {{financeiro.valor_juros}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Multa: {{financeiro.valor_multa}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Custo cartório: {{financeiro.valor_custos_cartorio}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Desconto: {{financeiro.valor_desconto}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Adiantado: {{financeiro.valor_adiantado}}</label>
              <label v-show="financeiro.expandir" class="w3-col s12">Saldo devedor: {{financeiro.saldo_devedor}}</label>
            </div>

          </div>
        </div>

        <div class="w3-left w3-col s12" >
          <h5 
            class="texto-vermelho" 
            style="margin-top:0px;">
            Total dos títulos: 
            <strong>{{formatarValor(total_financeiros_abertos, 2)}}</strong>
          </h5>  
        </div>
        
      </div>
    </div>

  </div>
</template>

<script>
  import legenda from '@/components/Legendas'
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import RCliente from '@/components/Rest/RCliente/RCliente.js'

  export default {
    name: "FinanceirosAbertoCliente",
    components: {legenda},
    mixins:[formatarValorMixin],
    data() {
      return {
        dados_cliente: undefined,
        financeiros_abertos: undefined,
        abrir_modal_financeiros_abertos: false,
        total_financeiros_abertos: 0,
      }
    },
    methods: {

      async buscarFinanceirosAbertos(cliente){
        try {
        
          if (!cliente.cadastro_id){
            Biblioteca.exclamar('Nenhum cliente foi selecionado!');
            return;
          }

          let parametros = {
            cadastro_id: cliente.cadastro_id 
          }

          let retorno = await RCliente.buscarFinanceirosAberto(this.axios, parametros);

          if (retorno.houve_erro == 'S'){
            throw new Error(retorno.mensagem);
          }

          this.dados_cliente = cliente;
          this.financeiros_abertos = retorno.dados;

          if (this.financeiros_abertos) {
            this.total_financeiros_abertos = 0;
            for (let i = 0; i < this.financeiros_abertos.length; i++) {
              this.financeiros_abertos[i].expandir = false;
              this.total_financeiros_abertos = this.total_financeiros_abertos + parseFloat(strPadraoToNumber(this.financeiros_abertos[i].valor_documento));
            }
          }

          this.abrir_modal_financeiros_abertos = true;
        } catch (error) {
          let mensagem = Biblioteca.tratamentoMensagem(error);
          Biblioteca.exclamar(mensagem);      
        }
      },

      mostrarDetalhes(index){
        this.financeiros_abertos[index].expandir = !this.financeiros_abertos[index].expandir;
        this.$forceUpdate();
      },

    },  
  }
</script>

<style escoped>

  .card-item {
    background: white;
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 5px !important;
    border: 2px solid #ccc;
  }

  .card-financeiro-aberto:hover {
    background: #ededed;
  }

  .card-financeiro-aberto {
    margin-bottom: 10px;
    border-left-style: solid;
    border-left-color: #636363 !important;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #636363 !important;
    background: #ffffff;
    color:#4f4f4f;
  }

  .texto-financeiro {
    margin:0; 
    padding:0; 
    font-size:12px; 
    font-weight:bold;
  }

</style>





// WEBPACK FOOTER //
// src/components/FinanceirosAbertoCliente.vue